import * as React from 'react'

import { List, useTranslate } from 'react-admin'

import { CreditLineDatagrid } from '../datagrids/creditLineDatagrid'
import { CreditLineEmpty } from '../emptyViews/creditLineEmptyView'
import { Pagination } from './pagination'
import PanelHeader from 'components/PanelHeader'

const CreditLinePagination = (props) => {
  return <Pagination {...props} rowsPerPageOptions={[10, 25, 50, 100]} />
}

export const CreditLineList = (props) => {
  return <CreditLineListCore {...props} />
}

export const CreditLineListCore = ({
  className,
  hasList,
  hasShow,
  hasEdit,
  ...props
}) => {
  const translate = useTranslate()

  return (
    <>
      <PanelHeader title={translate('resources.creditlines.name')} />
      <List
        className={className}
        {...props}
        hasList={hasList}
        hasShow={hasShow}
        hasEdit={hasEdit}
        bulkActionButtons={false}
        actions={<></>}
        pagination={<CreditLinePagination />}
        title={translate('resources.creditlines.name')}
        empty={<CreditLineEmpty {...props} />}
      >
        <CreditLineDatagrid {...props} />
      </List>
    </>
  )
}
